import { formatMoney } from '@/lib/format';
import type { PaymentBreakdownRow } from '@/lib/types';

interface PaymentBreakdownCardProps {
  breakdown: PaymentBreakdownRow[];
  currencySymbol: string;
}

export default function PaymentBreakdownCard({
  breakdown,
  currencySymbol,
}: PaymentBreakdownCardProps) {
  const grandTotal = breakdown.reduce((s, r) => s + Number(r.total), 0);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="font-heading text-lg font-semibold text-foreground-950">
        Desglose por método de pago
      </h2>

      {breakdown.length === 0 ? (
        <div className="mt-4 rounded-md border border-dashed border-background-300 p-6 text-center text-sm text-foreground-500">
          Sin ventas registradas en este período.
        </div>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm min-w-[420px]">
            <thead className="text-foreground-600 text-left border-b border-background-200">
              <tr>
                <th className="py-2 font-medium">Método</th>
                <th className="py-2 font-medium text-center">Ventas</th>
                <th className="py-2 font-medium text-right">Total</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-100">
              {breakdown.map((r) => (
                <tr key={r.method}>
                  <td className="py-2.5 text-foreground-900">{r.label}</td>
                  <td className="py-2.5 text-center text-foreground-700">{r.count}</td>
                  <td className="py-2.5 text-right font-medium text-foreground-950">
                    {formatMoney(Number(r.total), currencySymbol)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="border-t border-background-200">
                <td className="py-2.5 font-heading font-semibold text-foreground-950" colSpan={2}>
                  Total
                </td>
                <td className="py-2.5 text-right font-heading font-bold text-foreground-950">
                  {formatMoney(grandTotal, currencySymbol)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}